class Maps {
    constructor() {

    }
    getMap(el) {
        // Get map object
        window.map = googleMaps.getMap(el);
    }
    initMap(el, callback) {
        googleMaps.init(el, callback);
    }
}

export default new Maps();
